/*
 * @Descripttion:
 * @version:
 * @Author: 周志国
 * @Date: 2025-09-09 14:27:36
 * @LastEditors: 周志国
 * @LastEditTime: 2025-09-10 14:58:28
 * @changeLog:
 * @FilePath: /anov-3d-webgl/packages/anov-3d-ability/src/business/Plane/types.ts
 */

import type { MeshBasicMaterialParameters } from '@anov/3d-core'

export type options = {
  length?: number
  width?: number
  lengthSegment?: number
  widthSegment?: number
  material?: MeshBasicMaterialParameters
}
